import { Controller } from 'stimulus';
import jump from 'jump.js';

class Detail extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onJump(event) {
    const target = event.currentTarget;

    if (!target.getAttribute('data-jump-to')) {
      return false;
    }

    const jumpTarget = document.querySelector(target.getAttribute('data-jump-to'));

    if (!jumpTarget) {
      return false;
    }

    jump(jumpTarget, {
      offset: -100,
    });

    return true;
  }
}

Detail.targets = [
  //
];

export default Detail;
